"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeliveryChannelCoordinatesQuery = void 0;
var _environment = require("@ori/environment");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _swrConfig = require("../constants/swrConfig");
var _logger = require("../logger");
var _utils = require("../utils");
const hookName = 'useDeliveryChannelCoordinatesQuery';
const useDeliveryChannelCoordinatesQuery = deliveryChannelId => {
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    language
  } = (0, _i18n.useLanguage)();
  const headers = (0, _react.useMemo)(() => (0, _utils.getHeaders)({
    currentLanguage: language,
    tenant
  }), [language, tenant]);
  const isActive = Boolean(deliveryChannelId);
  if (isActive) {
    (0, _logger.logDebug)(`${hookName} hook called, params:`, deliveryChannelId);
  }
  const swrOptions = {
    ..._swrConfig.errorHandlingSwrOptions,
    enabled: isActive,
    onSuccess: data => (0, _logger.logInfo)(`${hookName} hook: DeliveryChannel data was loaded:`, data)
  };
  const {
    data: deliveryChannelCoordinates,
    isValidating: isDeliveryChannelCoordinatesLoading
  } = (0, _globalApiClientReact.useGetDeliveryChannelCoordinates)(deliveryChannelId ?? 0, headers, {
    swr: swrOptions
  });
  return {
    deliveryChannelCoordinates,
    isDeliveryChannelCoordinatesLoading
  };
};
exports.useDeliveryChannelCoordinatesQuery = useDeliveryChannelCoordinatesQuery;